var map = {
	"./John-Hopkins-University.png": 5686,
	"./QuilinX.jpeg": 9572,
	"./Sarthaklogo.svg": 5225,
	"./abyeti.png": 7248,
	"./api_holdings.jpeg": 9887,
	"./apollo247.png": 518,
	"./apollopharmacy.jpeg": 1898,
	"./bhavans.png": 3338,
	"./celery.jpeg": 185,
	"./clevertap.png": 1133,
	"./colorado.png": 3769,
	"./dagster.avif": 537,
	"./docon_emr.png": 9677,
	"./docon_patient.webp": 105,
	"./duke_university.png": 9898,
	"./google_search_console.jpeg": 9409,
	"./hacktoberfest.jpeg": 5536,
	"./hacktoberfest11.png": 4023,
	"./hacktoberfest2025.png": 2389,
	"./illinois.png": 5697,
	"./linkedIn_RisingStar.jpeg": 5143,
	"./mechademy.jpeg": 2815,
	"./pharmeasy.png": 6291,
	"./sandipani.webp": 3393,
	"./stanford_logo.png": 3777,
	"./thyronxt.png": 6622,
	"./tiger-data.webp": 7448,
	"./vitvellore.jpeg": 7594,
	"./yamaha.jpeg": 1837
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;